<div class="dm-lap">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Digitális munkarend</ion-card-title>
      <ion-card-subtitle>
        A tantermen kívüli, digitális munkarend elrendelt időszakai (Nkt. 27. § (1), (2a)). A tanév rendje szerinti
        időszakot (2026/2027: a gimnázium és a szakgimnázium 9–11. évfolyamán május 3–7.) a naptárban a beemelt
        bejegyzésből érdemes indítani; itt kézzel is felvehető és visszavonható.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="dm-fej">
        <ion-select label="Tanév" label-placement="stacked" interface="popover" [(ngModel)]="tanev" (ionChange)="betolt()">
          <ion-select-option *ngFor="let t of tanevek" [value]="t">{{ t }}/{{ t + 1 }}</ion-select-option>
        </ion-select>
        <ion-button *ngIf="szerkesztheto" size="small" (click)="uj()">
          <ion-icon slot="start" name="add-circle-outline"></ion-icon>Új időszak
        </ion-button>
      </div>

      <div *ngIf="toltodik">Betöltés…</div>
      <ion-note color="danger" *ngIf="hiba">{{ hiba }}</ion-note>
      <p class="halvany" *ngIf="!toltodik && !hiba && !idoszakok.length">Ebben a tanévben nincs elrendelt digitális munkarend.</p>

      <table class="dm-tabla" *ngIf="!toltodik && idoszakok.length">
        <thead>
          <tr><th>Időszak</th><th>Érintett osztályok</th><th>Ok, jogalap</th><th>Rögzítette</th><th></th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let x of idoszakok">
            <td class="dm-datum">{{ x.tol }}<span *ngIf="x.ig !== x.tol"> – {{ x.ig }}</span>
              <div class="halvany" *ngIf="x.tkt_id">a naptárbejegyzésből</div></td>
            <td>{{ osztalyNevek(x) }}<div class="halvany">{{ kor(x) }}</div></td>
            <td>{{ x.ok || '—' }}<div class="halvany" *ngIf="x.jogalap">{{ x.jogalap }}</div></td>
            <td>{{ x.rogzitette_nev || x.rogzitette || '—' }}<div class="halvany" *ngIf="x.letrehozva">{{ x.letrehozva | date:'yyyy.MM.dd HH:mm' }}</div></td>
            <td>
              <ion-button *ngIf="szerkesztheto" size="small" fill="clear" color="danger" (click)="torol(x)" title="Visszavonás">
                <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
              </ion-button>
            </td>
          </tr>
        </tbody>
      </table>

      <ion-note color="medium" class="dm-megj">
        A hatás: az érintett osztályok óráin a napló képernyője és a napló nyomtatványa „digitális munkarend” jelölést
        mutat, a szülők és a tanulók a kezdőlapjukon látják. A mulasztás számítása nem változik – a jelenlét ilyenkor az
        online részvétel, a távolmaradást a szokásos módon kell jelölni. Rögzíteni és visszavonni naptár-admin tud.
      </ion-note>
    </ion-card-content>
  </ion-card>
</div>
